
__webpack_require__.debugRequireIds = {
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.1/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/google-sprite.css": 53294,
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.1/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/twitter-sprite.css": 934,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/google-sprite.css": 56382,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/twitter-sprite.css": 54006,
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 27581,
	"./generated/emoji/google.webp": 94213,
	"./generated/emoji/twitter.webp": 60889,
	"./src/base_page_params.ts": 3698,
	"./src/blueslip.ts": 67040,
	"./src/blueslip_stacktrace.ts": 33622,
	"./src/bot_types.ts": 23603,
	"./src/bundles/common.ts": 35013,
	"./src/bundles/legacy_portico_bundle.ts": 85291,
	"./src/csrf.ts": 1156,
	"./src/i18n.ts": 40322,
	"./src/loading_error.ts": 57553,
	"./src/portico/google-analytics.ts": 75781,
	"./src/portico/legacy_header.ts": 70610,
	"./src/portico/portico_modals.ts": 91076,
	"./src/portico/tippyjs.ts": 27294,
	"./src/realm_user_settings_defaults.ts": 26646,
	"./src/retry_backoff.ts": 42797,
	"./src/sentry.ts": 333,
	"./src/state_data.ts": 80096,
	"./src/stream_types.ts": 2036,
	"./src/types.ts": 51441,
	"./src/user_settings.ts": 24729,
	"./src/user_status_types.ts": 10264,
	"./src/util.ts": 45926,
	"./styles/portico/collaborychat_auth.css": 7817,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"@sentry/conventions/attributes": 59966,
	"@zxcvbn-ts/dictionary-compression/decompress": 81395,
	"altcha": 26971,
	"core-js/modules/es.array-buffer.detached.js": 19000,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 32169,
	"core-js/modules/es.array-buffer.transfer.js": 60025,
	"core-js/modules/es.array.includes.js": 54508,
	"core-js/modules/es.array.push.js": 94361,
	"core-js/modules/es.iterator.constructor.js": 16608,
	"core-js/modules/es.iterator.filter.js": 79944,
	"core-js/modules/es.iterator.find.js": 70001,
	"core-js/modules/es.iterator.map.js": 72542,
	"core-js/modules/es.iterator.some.js": 75390,
	"core-js/modules/es.json.parse.js": 9999,
	"core-js/modules/es.json.stringify.js": 27761,
	"core-js/modules/es.map.get-or-insert-computed.js": 47180,
	"core-js/modules/es.map.get-or-insert.js": 40870,
	"core-js/modules/es.set.difference.v2.js": 93535,
	"core-js/modules/es.set.intersection.v2.js": 2665,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 18052,
	"core-js/modules/es.set.is-subset-of.v2.js": 92025,
	"core-js/modules/es.set.is-superset-of.v2.js": 54402,
	"core-js/modules/es.set.symmetric-difference.v2.js": 36617,
	"core-js/modules/es.set.union.v2.js": 54725,
	"core-js/modules/es.typed-array.with.js": 10722,
	"core-js/modules/es.uint8-array.set-from-base64.js": 61693,
	"core-js/modules/es.uint8-array.set-from-hex.js": 48789,
	"core-js/modules/es.uint8-array.to-base64.js": 33775,
	"core-js/modules/es.uint8-array.to-hex.js": 72791,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"jquery-validation": 9905,
	"lodash": 35558,
	"micromodal": 94456,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 81988
};